import {
  ImageFormat,
  canvasToBuffer,
  loadImageOnCanvas,
  resizeCanvas,
} from 'services/utility/image/resizeImage';

export const resizeImage = async (
  image: string,
  width: number,
  height: number,
  quality = 0.9,
  type = ImageFormat.JPEG,
) => {
  const canvas = await loadImageOnCanvas(image);
  const resizeResult = resizeCanvas(canvas, width, height, false);
  return await canvasToBuffer(resizeResult, type, quality);
};
